import script from "./IndexPart1.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPart1.vue?vue&type=script&setup=true&lang=js"

import "./IndexPart1.vue?vue&type=style&index=0&id=6e630f33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e630f33"]])

export default __exports__